import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, Button, Paper, Alert } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { useCart } from "../context/CartContext";

export default function OrderConfirmation() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { setTable } = useCart();
  const order = state?.order;
  const table = state?.table;
  const kotPrintError = state?.kotPrintError;

  return (
    <Box sx={{ minHeight: "100dvh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", p: 3, textAlign: "center" }}>
      <Paper elevation={0} sx={{ p: 4, borderRadius: 4, bgcolor: "success.50", width: "100%", maxWidth: 360 }}>
        <CheckCircle color="success" sx={{ fontSize: 72 }} />
        <Typography variant="h5" fontWeight={800} mt={2}>
          Order Placed
        </Typography>
        <Typography color="text.secondary" mt={1}>
          {table ? `Sent to the kitchen for ${table.name}.` : "Sent to the kitchen."}
        </Typography>
        {order?.order_no && (
          <Typography variant="body2" color="text.disabled" mt={1}>
            Order #{order.order_no}
            {order.token_no ? ` (#${order.token_no})` : ""}
          </Typography>
        )}
      </Paper>

      {kotPrintError && (
        <Alert severity="warning" sx={{ mt: 2, width: "100%", maxWidth: 360 }}>
          Order saved, but the kitchen printer didn't receive it: {kotPrintError}. Please flag this to staff.
        </Alert>
      )}

      <Button
        variant="contained"
        size="large"
        sx={{ mt: 4, px: 5 }}
        onClick={() => {
          // clearCart() (called before we ever got here — see Cart.js
          // handlePlaceOrder) deliberately keeps the table selected, for a
          // waiter placing a follow-up round on the same table straight from
          // Home. "New Order" from the confirmation screen is the opposite
          // case — the waiter is done with this table and moving on — so the
          // stale selection needs clearing here instead, or the next order
          // silently goes to whichever table was last used.
          setTable(null);
          navigate("/", { replace: true });
        }}
      >
        New Order
      </Button>
    </Box>
  );
}
